import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import FancyTitle from '../fancy-title';

function Achievements({ blok }) {
  return (
    <div {...storyblokEditable(blok)}>
      <h1>Achievements</h1>
    </div>
  );
}

export default Achievements;
